import React, { useEffect, useState } from "react";
import HomeFaq from "./FAQPage";

export default function HomeDashboard({
    setStartChat,
    faqs,
    setRoomview,
    roomToken,
    miniMize,
    sendMessage,
}) {
    const [showfaqs, setShowFaqs] = useState(false)
    const [selectedFaq, selectFAQ] = useState(null)
    return (
        <>{showfaqs ?
            <HomeFaq
                miniMize={miniMize}
                setShowFaqs={setShowFaqs}
                setStartChat={setStartChat}
                selectedFaq={selectedFaq}
                selectFAQ={selectFAQ}
                setRoomview={setRoomview}
                roomToken={roomToken}
                faqs={faqs}
                sendMessage={sendMessage} /> :
            <div id="container">
                <main>
                    <header class="landing">
                        <div class="header-icon">
                            <span></span>
                            <aside class="heading-text">
                                <h2> Hey! </h2>
                                <p>I am Tia, simplifying your home insurance needs </p>
                            </aside>
                        </div>


                        <div class="closeIcon" onClick={() => miniMize()}>✕</div>


                    </header>
                    <div class="chat-intro-wrapper">
                        <div class="chat-invitation">
                            <p class="heading-gray">Start a new conversation</p>
                            <span class="send-msg" onClick={() => {
                                setStartChat(true)
                                setRoomview(roomToken)
                            }
                            }

                            >
                                Send us a messsage
                            </span>

                        </div>
                        <div class="chat-faq" >
                            <p class="heading-gray">Frequently asked questions</p>
                            <div class="searchbox">
                                <input type="text" onClick={() => setShowFaqs(true)} placeholder="Search your questions" />
                                <span class="search-icon"></span>
                            </div>
                            <ul class="faq-load">
                                {faqs.slice(0, 2).map((item, index) =>
                                    <li>
                                        <a onClick={() => {
                                            setShowFaqs(true)
                                            selectFAQ(item.question)
                                        }} >{item.question}</a>
                                    </li>
                                )}

                            </ul>
                            <div  class="viewall_warpper">
                                <a onClick={() => setShowFaqs(true)} ><span>View more</span></a>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        }</>
    );
}
